import { render } from "./GtTest.vue?vue&type=template&id=13a77ff4&scoped=true&ts=true"
import script from "./GtTest.vue?vue&type=script&lang=ts"
export * from "./GtTest.vue?vue&type=script&lang=ts"

import "./GtTest.vue?vue&type=style&index=0&id=13a77ff4&lang=less&scoped=true"

import exportComponent from "F:\\工作资料\\公司网站资料\\phone\\gtwebphone的副本\\gtwebphone的副本\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13a77ff4"]])

export default __exports__